<pt-feature-info />
<pt-breadcrumbs class="bg-white" [breadcrumbs]="breadcrumbs$ | async" />
<div class="border-b border-solid border-slate-300"></div>

<div class="wrapper" fxLayout="column" fxLayoutGap="16px">
  <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="16px">
    <h1 class="mat-headline-4">Practices</h1>
    <pt-buttons-container>
      <button mat-flat-button color="primary" (click)="add()">
        Create Practice
      </button>
    </pt-buttons-container>
  </div>

  <ng-container *ngIf="practices$ | async as practices">
    <mat-list *ngIf="practices.length; else noPractices">
      <pr-practice-list-item
        *ngFor="let practice of practices; trackBy: trackByPractice"
        [practice]="practice"
      />
    </mat-list>
    <ng-template #noPractices>
      <pr-empty-state image="list" title="practices" />
    </ng-template>
  </ng-container>
</div>
